export default __webpack_public_path__ + "static/mesheryui-c85131f04313bafd3a0b677304a229a3.webp";